import { useCallback } from 'react'
import { useCreateSeason } from '~/api/supabase-mutations'
import { buildNextSeason } from '../generators/create-next-season-generator'

export const useCreateNextSeason = () => {
  const { createSeason } = useCreateSeason()

  const createNextSeason = useCallback(async ({ farmId, currentYear }, options = {}) => {
    const seasonData = buildNextSeason({ farmId, currentYear })
    return createSeason(seasonData, options)
  }, [createSeason])

  return { createNextSeason }
}
